import React, { useEffect } from 'react';
import { styled } from 'linaria/react';
import { useTracker } from '@jetshop/core/analytics/Analytics';
import { trackListEvent } from '@jetshop/core/analytics/tracking';
import { RelatedProduct } from './RelatedProduct';
import { ScrollBox } from '../../ui/ScrollBox';
import { theme } from '../../Theming/Theming';
import { ProductListHeader } from '../StyledComponents';

const RelatedWrapper = styled('div')`
  margin: 2rem 0 1rem 0;
  width: 100%;
  > h2 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .related-product-grid {
    display: flex;
    flex-wrap: wrap;
    background: ${theme.colors.backgroundLight};
    > * {
      width: 100%;
    }
    .slider-items {
      > * {
        width: 90%;
        ${theme.above.md} {
          width: 55%;
        }
        ${theme.above.lg} {
          width: 35%;
        }
      }
    }
    button.prev {
      left: 0;
    }
    button.next {
      right: 0;
    }
  }
`;

const RelatedProductsAddon = ({ products, title }) => {
  //TRACK LIKE PRODUCTGRID
  const track = useTracker();
  useEffect(() => {
    // Dont track anything if there are no products to render
    if (!products || products.length === 0) return;
    // Otherwise track a list view event
    track(
      trackListEvent({
        listName: 'Related Products Addon',
        products,
        category: '',
      })
    );
  }, [products, track]);

  if (!products) return null;

  return (
    <RelatedWrapper id="related-products">
      <ProductListHeader>{title}</ProductListHeader>
      <div className="related-product-grid">
        <ScrollBox>
          {products.map((product, index) => {
            return (
              <RelatedProduct product={product} quickBuy={true} key={index} />
            );
          })}
        </ScrollBox>
      </div>
    </RelatedWrapper>
  );
};

export default RelatedProductsAddon;
